import { createContext, useContext } from 'react';

const ModalStackItemContext = createContext({ isActive: false });

export const useModalStackItem = () => useContext(ModalStackItemContext);

export default ModalStackItemContext;
